// NPM Imports
import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MultiSelect } from "react-multi-select-component";
import { Input, Toastr, Tooltip } from "../../../revvComponents";

// Components Imports
import { CustomSelect, DateSelect } from "../../../commonComponents";
// Actions Imports

// Internal Imports

// Destructuring

// Declarations
const ICONS = {
  TEXT: ["far", "font-case"],
  DATE: ["far", "calendar-days"],
  NUMBER: ["far", "input-numeric"],
  SINGLE_SELECT: ["far", "list-radio"],
  MULTI_SELECT: ["far", "list-check"],
};

export default function MetaFieldItem({
  metaFieldItem,
  metaFieldItemName,
  canBeDeleted,
  handleDeleteMetaField,
  handleUpdateMetaField,
  availableOptions,
  defaultValues,
}) {
  const [updatedMetaFieldValue, handleUpdatedMetaFieldValue] = useState(
    defaultValues || "",
  );

  const updateMetaFieldValue = InputTypeUpdatedValue => {
    switch (metaFieldItem.field_type) {
      case "TEXT":
      case "NUMBER": {
        if (updatedMetaFieldValue === metaFieldItem.value) {
          Toastr.showToastr({
            type: "failure",
            message: "Nothing to update.",
            timeout: 6000,
          });
        } else if (updatedMetaFieldValue && updatedMetaFieldValue !== "") {
          handleUpdateMetaField(
            metaFieldItem,
            metaFieldItemName,
            updatedMetaFieldValue,
          );
          Toastr.showToastr({
            type: "success",
            message: "Metafield saved successfully!",
            timeout: 6000,
          });
        } else {
          Toastr.showToastr({
            type: "failure",
            message: "Metafield name cannot be empty.",
            timeout: 6000,
          });
        }
        break;
      }
      case "DATE": {
        handleUpdatedMetaFieldValue(InputTypeUpdatedValue);
        if (InputTypeUpdatedValue === metaFieldItem.value) {
          Toastr.showToastr({
            type: "failure",
            message: "Nothing to update.",
            timeout: 6000,
          });
        } else if (InputTypeUpdatedValue && InputTypeUpdatedValue !== "") {
          handleUpdateMetaField(
            metaFieldItem,
            metaFieldItemName,
            InputTypeUpdatedValue.default,
          );
          Toastr.showToastr({
            type: "success",
            message: "Metafield saved successfully!",
            timeout: 6000,
          });
        } else {
          Toastr.showToastr({
            type: "failure",
            message: "Metafield name cannot be empty.",
            timeout: 6000,
          });
        }
        break;
      }
      case "SINGLE_SELECT": {
        handleUpdatedMetaFieldValue(InputTypeUpdatedValue);
        if (updatedMetaFieldValue === metaFieldItem.value) {
          Toastr.showToastr({
            type: "failure",
            message: "Nothing to update.",
            timeout: 6000,
          });
        } else if (InputTypeUpdatedValue && InputTypeUpdatedValue.value) {
          handleUpdateMetaField(
            metaFieldItem,
            metaFieldItemName,
            InputTypeUpdatedValue.value,
          );
          Toastr.showToastr({
            type: "success",
            message: "Metafield saved successfully!",
            timeout: 6000,
          });
        } else {
          Toastr.showToastr({
            type: "failure",
            message: "Metafield name cannot be empty.",
            timeout: 6000,
          });
        }
        break;
      }
      case "MULTI_SELECT": {
        if (updatedMetaFieldValue === metaFieldItem.value) {
          Toastr.showToastr({
            type: "failure",
            message: "Nothing to update.",
            timeout: 6000,
          });
        } else if (Array.isArray(updatedMetaFieldValue)) {
          const updatedValue = [];
          updatedMetaFieldValue.forEach(fieldValue =>
            updatedValue.push(fieldValue.value),
          );
          handleUpdateMetaField(metaFieldItem, metaFieldItemName, updatedValue);
          Toastr.showToastr({
            type: "success",
            message: "Metafield saved successfully!",
            timeout: 6000,
          });
        } else {
          Toastr.showToastr({
            type: "failure",
            message: "Metafield name cannot be empty.",
            timeout: 6000,
          });
        }
        break;
      }
      default: {
        break;
      }
    }
  };

  const handleKeyDown = e => {
    if (e.key === "Enter") {
      updateMetaFieldValue(metaFieldItemName);
    }
  };
  const handleInputTypes = type => {
    switch (type) {
      case "TEXT":
      case "NUMBER":
        return (
          <Tooltip
            placement="top"
            align={{
              offset: [0, 3],
            }}
            overlay={"Press enter to save"}>
            <Input
              className="metafield-name-update"
              onBlur={() => {}}
              onKeyDown={e => handleKeyDown(e)}
              value={updatedMetaFieldValue}
              onChange={e => handleUpdatedMetaFieldValue(e.target.value)}
              data-test="pricelist-search-input"
            />
          </Tooltip>
        );
      case "DATE":
        return (
          <DateSelect
            className="metafield-create-input"
            returnValue={value => updateMetaFieldValue({ default: value })}
            value={updatedMetaFieldValue}
          />
        );
      case "SINGLE_SELECT":
        return (
          <CustomSelect
            // className="metafield-create-input"
            className="metafield-create-input"
            _handleChangeInSelect={e => updateMetaFieldValue(e)}
            // onMenuClose={updateMetaFieldValue}
            options={availableOptions}
            value={updatedMetaFieldValue}
          />
        );
      case "MULTI_SELECT":
        return (
          <MultiSelect
            options={availableOptions}
            value={updatedMetaFieldValue}
            onChange={handleUpdatedMetaFieldValue}
            onMenuToggle={e => !e && updateMetaFieldValue()}
            labelledBy={"Select"}
            data-test="multi-select-dropdown"
            disableSearch
          />
        );
      default:
        return (
          <Input
            className="metafield-name-update"
            // onBlur={updateMetaFieldName(updatedMetaFieldName)}
            onKeyDown={() => {}}
            value={updatedMetaFieldValue}
            onChange={e => handleUpdatedMetaFieldValue(e.target.value)}
            data-test="pricelist-search-input"
          />
        );
    }
  };

  return (
    <div className="meta-field-item-view" key={metaFieldItemName}>
      <span
        key={metaFieldItemName}
        className="meta-field-item"
        onClick={() => {}}
        // onClick={() => handleNameUpdateClick(true)}
        onKeyPress={() => {}}
        role="button"
        tabIndex={"0"}>
        <FontAwesomeIcon
          icon={ICONS[metaFieldItem.field_type]}
          color="#91A5C9"
          className="metafield-itemicon"
        />
        <span className="meta-field-details">
          <span
            // onClick={() => {}}
            onClick={() => {}}
            className="metafield-name"
            onKeyPress={() => {}}
            role="button"
            tabIndex={"0"}>
            {metaFieldItemName}
          </span>
          {handleInputTypes(metaFieldItem.field_type)}
        </span>
      </span>
      {canBeDeleted && (
        <span
          onClick={() => handleDeleteMetaField(metaFieldItemName)}
          onKeyPress={() => {}}
          role="button"
          tabIndex={"0"}
          className="meta-field-item-delete">
          <FontAwesomeIcon icon={["far", "trash-alt"]} />
        </span>
      )}
    </div>
  );
}
